
import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { simpleAddress } from "../../util";
import { AiOutlineMinus, AiOutlineClose } from "react-icons/ai";
import { FaTwitter, FaTelegramPlane, FaInstagram, FaFacebookF, FaGithub } from "react-icons/fa";
import { FlashLogoSvg } from '../../assets/svg/svg';
import "./header.scss";
import WalletModal from '../WalletModal';
import { useSelector, useDispatch } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import { getAddress, sendBtcTransaction } from "sats-connect";
import { useNavigate } from 'react-router-dom';

const Header = () => {
	const [walletModal, setWalletModal] = useState(false);
	const [isMobile, setIsMobile] = useState(false);
	const navigate = useNavigate();

	const pageMove = (id: any) => {
		navigate(id);
	}



	return (
		<header className=' header_'>
			<div className='container flex header-container'>
				<div className='flex items-center justify-between mobile-just-start flex4 row-reverse-991'>
					<div className='flex items-center justify-between w-full lg:w-0 flex-row-reverse sm:flex-row'>
						<div onClick={() => setIsMobile(true)} className='hamburger-icon-container'>
							<AiOutlineMinus className='' style={{ position: 'absolute', top: '0%' }} fontSize={'25px'} />
							<AiOutlineMinus className='' style={{ position: 'absolute', top: '20%' }} fontSize={'25px'} />
							<AiOutlineMinus className='' style={{ position: 'absolute', top: '40%' }} fontSize={'25px'} />
						</div>
						<Link to='/' className='header-logo-container'>
							<div className="header-logo" >
								{/* <img src="/flash-logo.svg" style={{ maxHeight: '100%', width: '100%' }} alt="flash-logo" className="" /> */}
								<div className="flex justify-center items-center">
									<FlashLogoSvg className="text-black" />
									<h2 className='primary-color !mt-1 sm:!mt-2' style={{ marginTop: '10px !important' }}>
										NFT
									</h2>
								</div>
							</div>
						</Link>
					</div>

					<div className={`${isMobile ? 'hamburger-box' : ''} justify`}>
						<div className={`${isMobile ? 'hamburger-cancel-container' : ''} dis-n`}>
							<AiOutlineClose onClick={() => setIsMobile(false)} className='cu-po hamburger-cancel-btn' fontSize={'30px'} color="white-color" />
						</div>
						<ul className='hamburger justify li-none-style text-white sm:text-black'>

							<li className='hamburger-list' onClick={() => pageMove('/')}>
								<a >Home</a>
							</li>
							<li className='hamburger-list' onClick={() => pageMove('/inscribe')}>
								<a >Inscribe</a>
							</li>
							<li className='hamburger-list' onClick={() => pageMove('/mint')}>
								<a >Mint</a>
							</li>
							<li className='hamburger-list' onClick={() => pageMove('/faq')}>
								<a >FAQ</a>
							</li>
						</ul>
					</div>
					<div onClick={() => setIsMobile(false)} className={`${isMobile ? 'hamburger-bg' : ''} dis-n`}></div>
				</div>
				<div className='launch-app-btn'>
					<div className='justify jc-e flex2 gap-2'>
						<button style={{ borderRadius: '2px', border: '1px grey solid' }} className='display-chain btn font-bold'>
							<div className='justify gap-2 px-0 sm:px-1'>
								<span className='black-color'>Ethereum</span>
							</div>
						</button>
						<button onClick={() => setWalletModal(true)} style={{ borderRadius: '0px' }} className='connect-wallet btn black-bg font-bold'>
							<div className='justify gap-2 px-0 sm:px-1'>
								<span className='text-white'>Connect to Wallet</span>
							</div>
						</button>
					</div>
				</div>
			</div>
			{walletModal &&
				<WalletModal setWalletModal={setWalletModal} />
			}
		</header>
	);
};

export default Header;
